import type React from "react"
import { Trans } from "react-i18next"
import { Link } from "react-router-dom"
import styles from "./MenuItem.module.css"

interface MenuItemProps {
  icon: string
  labelKey: string
  route: string
  external?: boolean
}

const MenuItem: React.FC<MenuItemProps> = ({
  icon,
  labelKey,
  route,
  external = false,
}) => {
  if (external) {
    return (
      <a className={styles.Root} href={route}>
        <i className={`${styles.Icon} ${icon}`} />
        <span className={styles.Label}>
          <Trans i18nKey={`menu.${labelKey}`} />
        </span>
      </a>
    )
  }

  return (
    <Link className={styles.Root} to={route}>
      <i className={`${styles.Icon} ${icon}`} />
      <span className={styles.Label}>
        <Trans i18nKey={`menu.${labelKey}`} />
      </span>
    </Link>
  )
}

export default MenuItem
